import { retrieveToken } from '../storage';
import {
  wrapFetch,
  apiFetch,
  apiError,
  REGISTRAZIONE_DATI_NON_CORRETTI,
  SALVATAGGIO_DATI_NON_CORRETTI,
} from './api';

const BASE_URL = process.env.REACT_APP_BACKEND_ENDPOINT;

export const getGruppi = (id, nome, page, size, sortby) => {
  const token = retrieveToken();
  const PATH = '/api/gruppi';
  let query =
    '?' +
    'page=' +
    page +
    '&size=' +
    size +
    '&sort=' +
    sortby +
    '&' +
    sortby +
    '.dir=ASC';
  if (id !== null) {
    query = query + '&id.equals=' + id;
  }
  if (nome !== null) {
    query += `&nome.contains=${encodeURIComponent(nome)}`;
  }
  const URL = BASE_URL + PATH + query;
  const authtoken = 'Bearer '.concat(token);
  return wrapFetch(
    apiFetch(URL, {
      method: 'GET',
      headers: {
        Authorization: authtoken,
      },
      withCredentials: true,
      credentials: 'include',
    }),
    apiError(),
  );
};

export const getCountGruppi = () => {
  const token = retrieveToken();
  const PATH = '/api/gruppi/count';
  const URL = BASE_URL + PATH;
  const authtoken = 'Bearer '.concat(token);
  return wrapFetch(
    apiFetch(URL, {
      method: 'GET',
      headers: {
        Authorization: authtoken,
      },
      withCredentials: true,
      credentials: 'include',
    }),
    apiError(),
  );
};

export const getCountGruppiFiltered = (id, nome) => {
  const token = retrieveToken();
  const PATH = '/api/gruppi/count';
  let query = '?';
  if (id !== null) {
    query = query + '&id.equals=' + id;
  }
  if (nome !== null) {
    query += `&nome.contains=${encodeURIComponent(nome)}`;
  }
  const URL = BASE_URL + PATH + query;
  const authtoken = 'Bearer '.concat(token);
  return wrapFetch(
    apiFetch(URL, {
      method: 'GET',
      headers: {
        Authorization: authtoken,
      },
      withCredentials: true,
      credentials: 'include',
    }),
    apiError(),
  );
};

export const getGruppo = (gruppoId) => {
  const token = retrieveToken();
  const authtoken = 'Bearer '.concat(token);
  const PATH = '/api/gruppi/' + gruppoId;
  const URL = BASE_URL + PATH;
  return wrapFetch(
    apiFetch(URL, {
      method: 'GET',
      headers: {
        Authorization: authtoken,
      },
      withCredentials: true,
      credentials: 'include',
    }),
    apiError({
      404: "Caricamento dati fallito: nessun gruppo corrispondente all'ID indicato.",
    }),
  );
};

export const createGruppo = (requestBody) => {
  const token = retrieveToken();
  const authtoken = 'Bearer '.concat(token);
  const PATH = '/api/gruppi';
  const URL = BASE_URL + PATH;

  return wrapFetch(
    apiFetch(URL, {
      method: 'POST',
      headers: {
        Authorization: authtoken,
        'Content-Type': 'application/json',
      },
      withCredentials: true,
      credentials: 'include',
      body: JSON.stringify(requestBody),
    }),
    apiError({
      // 404 if the gruppoId does not correspond to a registered Gruppo
      400: REGISTRAZIONE_DATI_NON_CORRETTI,
      409: 'Registrazione non riuscita: esiste già un gruppo registrato con il nome indicato.',
    }),
  );
};

export const updateGruppo = (requestBody) => {
  const token = retrieveToken();
  const authtoken = 'Bearer '.concat(token);
  const PATH = '/api/gruppi';
  const URL = BASE_URL + PATH;
  return wrapFetch(
    apiFetch(URL, {
      method: 'PUT',
      headers: {
        Authorization: authtoken,
        'Content-Type': 'application/json',
      },
      withCredentials: true,
      credentials: 'include',
      body: JSON.stringify(requestBody),
    }),
    apiError({
      400: SALVATAGGIO_DATI_NON_CORRETTI,
      409: 'Salvataggio non riuscito: esiste già un gruppo con lo stesso nome.',
    }),
  );
};
